"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _IceDrawer = _interopRequireDefault(require("./IceDrawer"));
var _IceSelect = _interopRequireDefault(require("@/components/common/IceSelect"));
var _IcePrint = _interopRequireDefault(require("@/components/common/IcePrint"));
var _IceQueryGridProps = _interopRequireDefault(require("./IceQueryGridProps"));
var _request = _interopRequireDefault(require("@/utils/request"));
var _dataGrid = require("@/utils/dataGrid");
var _store = _interopRequireDefault(require("@/store"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IceQueryGrid',
  components: {
    IceDrawer: _IceDrawer.default,
    IceSelect: _IceSelect.default,
    IcePrint: _IcePrint.default
  },
  mixins: [_IceQueryGridProps.default],
  data: function data() {
    return {
      tableHeight: 470,
      advanceQuery: false,
      loading: true,
      gridData: [],
      selections: [],
      isReDoSelection: false,
      // 是否由重新选择触发，主要用于已选择数据默认选中
      // 查询参数
      defaultQueryText: '请输入搜索关键字',
      defaultQueryValue: '',
      total: 0,
      radio: '',
      // 单选
      werks: '',
      // 工厂编号 过滤当前人所在工厂
      bukrs: '',
      // 公司编号  过滤当前人所在公司
      pageParams: {
        sortColumn: '',
        // 总条数
        pageNum: 1,
        pageSize: 10
      },
      drawerRefresh: true,
      drawerRefreshId: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.handleQuery();
    this.reDoSelection();
    // 监听窗口大小变化
    if (this.resize) {
      window.onresize = this.reLayout;
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 清除定时器，防止内存泄漏
    var timerId = sessionStorage.getItem('drawerRefreshId');
    if (timerId) {
      clearInterval(timerId);
      sessionStorage.removeItem('drawerRefreshId');
    }

    // 清除窗口大小变化监听
    if (this.resize) {
      window.onresize = null;
    }
  },
  watch: {
    advanceQuery: {
      handler: function handler(newVal, oldVal) {
        var _this = this;
        var timerId = sessionStorage.getItem('drawerRefreshId');
        if (timerId) {
          clearInterval(timerId);
          sessionStorage.removeItem('drawerRefreshId');
        }
        if (newVal) {
          this.resetQuery();
          this.defaultQueryValue = '';
          // 降低频率到 50ms (20FPS)，减少性能消耗
          var newTimerId = setInterval(function () {
            _this.drawerRefresh = false;
            _this.drawerRefresh = true;
          }, 50);
          sessionStorage.setItem('drawerRefreshId', newTimerId);
        }
      }
    },
    gridDataList: function gridDataList() {
      this.reDoSelection();
    },
    dataUrl: function dataUrl(newvalue) {
      var _this2 = this;
      this.$nextTick(function (_) {
        return _this2.handleQuery();
      });
    },
    // 数据列信息发生变化，重新对网格布局，防止网格抖动
    columns: function columns() {
      var _this3 = this;
      this.$nextTick(function (_) {
        _this3.$refs.eltable.doLayout();
      });
    },
    // 数据列信息发生变化，重新对网格布局，防止网格抖动
    hasCheckBox: function hasCheckBox() {
      var _this4 = this;
      this.$nextTick(function (_) {
        _this4.$refs.eltable.doLayout();
      });
    },
    // 数据列信息发生变化，重新对网格布局，防止网格抖动
    gridIndex: function gridIndex() {
      var _this5 = this;
      this.$nextTick(function (_) {
        _this5.$refs.eltable.doLayout();
      });
    },
    'pageParams.pageNum': {
      handler: function handler() {
        var lastPage = Math.ceil(this.total / this.pageParams.pageSize);
        if (this.pageParams.pageNum === lastPage) {
          this.handleQuery();
        }
      }
    }
  },
  computed: {
    filterQuery: function filterQuery() {
      return this.query.filter(function (item) {
        return item.type !== 'static' && item.type !== 'tab' && typeof item.value !== 'function';
      });
    },
    defaultQueryPlaceholder: function defaultQueryPlaceholder() {
      var placeholder = [];
      // 使用find代替filter，只获取第一个满足条件的元素
      var defaultItem = this.query.find(function (item) {
        return item.default;
      });
      if (defaultItem) {
        placeholder.push(defaultItem.label);
      }
      // 如果没有找到默认项，显示通用提示
      var pp = placeholder.length > 0 ? '请输入：' + placeholder[0] : '请输入查询条件';
      return pp;
    },
    hasCheckBox: function hasCheckBox() {
      if (this.chooseItem == 'multiple') {
        return true;
      }
      return false;
    },
    computedOperationsWidth: function computedOperationsWidth() {
      return this.operationsWidth || this.operations.length * 50;
    }
  },
  methods: {
    setOpenType: function setOpenType(btnName) {
      if (btnName === '新增') this.$parent.openType = 'add';else if (btnName === '编辑') this.$parent.openType = 'edit';else if (btnName === '查看') this.$parent.openType = 'view';
    },
    getData: function getData(data) {},
    // grid表格重新调整大小
    doLayout: function doLayout() {
      this.$nextTick(function () {
        this.$refs.eltable.doLayout();
      });
    },
    // 多选
    selectAll: function selectAll(data) {
      this.$emit('select-all-data', data);
    },
    reLayout: function reLayout() {
      var _this6 = this;
      this.$nextTick(function () {
        if (_this6.scanTag) {
          // 扫码收货
          _this6.tableHeight = window.innerHeight - 396;
        } else {
          _this6.tableHeight = window.innerHeight - 115;
        }
      });
    },
    /** 勾选checkBox时的事件*/select: function select(_select, row) {
      this.$emit('select', _select, row);
    },
    // 双击单个单元格触发的事件
    cellDblClick: function cellDblClick(row, column, cell, event) {
      if (!column.label || column.label == '操作' || column.label == '序号') {
        return;
      }
      this.$emit('cellDblClick', row, column, cell, event);
    },
    rowDbclick: function rowDbclick(row, type, type1) {
      var bt = this.operations.find(function (item) {
        return item.dbclick === true;
      });
      if (bt && bt.callback) {
        bt.callback(row);
      }
      if (this.chooseItem == 'single') {
        var _row$this$codeProp;
        // 双击单选进入，多选不用resetQuery
        this.radio = (_row$this$codeProp = row[this.codeProp]) !== null && _row$this$codeProp !== void 0 ? _row$this$codeProp : row.id; // 单选
        this.$emit('dbClick', row);
      }
      // 双击调用父组件的查看功能
      if (this.dbClickBtn) {
        this.$parent.returnDbClick(row);
      }
    },
    handleSelectionChange: function handleSelectionChange(selections) {
      var _this7 = this;
      if (!this.isReDoSelection) {
        var removeSelections = this.selections.filter(function (item) {
          return !selections.find(function (sele) {
            return item[_this7.codeProp] === sele[_this7.codeProp];
          });
        });
        this.selections = (0, _toConsumableArray2.default)(selections);
        this.$emit('selection-change', selections, removeSelections);
      }
      this.isReDoSelection = false;
    },
    rowClick: function rowClick(row) {
      this.toggleSelection(row);
      this.$emit('rowClick', row);
    },
    toggleSelection: function toggleSelection(row) {
      this.$set(this.selections, this.selections.length, row);
      if (this.chooseItem == 'multiple') {
        this.$refs.eltable.toggleRowSelection(row);
        return;
      }
      if (this.chooseItem == 'single') {
        var _this$$refs$eltable, _row$this$codeProp2;
        (_this$$refs$eltable = this.$refs.eltable) === null || _this$$refs$eltable === void 0 || _this$$refs$eltable.setCurrentRow(row);
        this.radio = (_row$this$codeProp2 = row[this.codeProp]) !== null && _row$this$codeProp2 !== void 0 ? _row$this$codeProp2 : row.id; // 单选
      }
    },
    toggleSelectionByIndex: function toggleSelectionByIndex(index) {
      this.toggleSelection(this.gridData[index]);
    },
    getSelections: function getSelections() {
      return this.selections;
    },
    getDataList: function getDataList() {
      return this.gridData;
    },
    cleanColumnSelect: function cleanColumnSelect() {
      if (this.$refs.eltable) {
        if (this.chooseItem == 'multiple') {
          this.$refs.eltable.clearSelection();
        } else if (this.chooseItem == 'single') {
          // 清除单选模式下的选中状态
          this.$refs.eltable.setCurrentRow(null);
          this.radio = '';
        }
      }
    },
    reDoSelection: function reDoSelection() {
      var _this8 = this;
      this.isReDoSelection = true;
      this.cleanColumnSelect();
      if (this.selectedCodes.length > 0 && this.codeProp) {
        var selection = this.gridData.filter(function (item) {
          return _this8.selectedCodes.find(function (code) {
            return code == item[_this8.codeProp];
          });
        });
        if (selection && selection.length > 0) {
          this.$nextTick(function () {
            if (_this8.chooseItem == 'multiple') {
              selection.forEach(function (row) {
                _this8.$refs.eltable.toggleRowSelection(row);
              });
            }
            if (_this8.chooseItem == 'single') {
              selection.forEach(function (row) {
                var _this8$$refs$eltable;
                (_this8$$refs$eltable = _this8.$refs.eltable) === null || _this8$$refs$eltable === void 0 || _this8$$refs$eltable.setCurrentRow(row);
              });
            }
            _this8.isReDoSelection = false;
            // this.$emit("re-selection",)
          });
        } else {
          this.isReDoSelection = false;
        }
        this.selections = selection;
      } else {
        this.selections = [];
        this.isReDoSelection = false;
      }
    },
    closeSelection: function closeSelection(value) {
      var _this9 = this;
      var row = this.gridData.find(function (item) {
        return item[_this9.codeProp] == value;
      });
      if (row) {
        this.$refs.eltable.toggleRowSelection(row, false);
      }
    },
    tableCurrentChangeHandler: function tableCurrentChangeHandler(currentRow, oldCurrentRow) {
      if (!currentRow) {
        return;
      }
      if (this.chooseItem == 'single') {
        this.selections = [currentRow];
        this.$emit('selection-change', this.selections, oldCurrentRow ? [oldCurrentRow] : []);
      }
      if (!!this.tableCurrentChange && typeof this.tableCurrentChange === 'function') {
        this.tableCurrentChange(currentRow, oldCurrentRow);
      }
    },
    buttonClick: function buttonClick(btn) {
      this.setOpenType(btn.name);
      typeof btn.callback === 'function' && btn.callback();
    },
    columnClick: function columnClick(item, index, callback, btn) {
      this.setOpenType(btn.name);
      typeof callback === 'function' && callback(item, index);
    },
    sortChange: function sortChange(obj) {
      this.pageParams.sortColumn = '';
      if (obj.order) {
        this.pageParams.sortColumn = obj.prop;
        if (obj.order == 'ascending') {
          this.pageParams.sortOrder = 'asc';
        } else {
          this.pageParams.sortOrder = 'desc';
        }
      }
      this.handleQuery();
    },
    indexMethod: function indexMethod(index) {
      return this.pageParams.pageNum * this.pageParams.pageSize - this.pageParams.pageSize + index + 1;
    },
    exportExcel: function exportExcel(exportUrl) {
      var _this0 = this;
      this.$confirm('是否确认导出?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var union = _this0.getParams();
        (0, _request.default)({
          url: exportUrl,
          method: 'POST',
          responseType: 'blob',
          data: union
        }).then(function (res) {
          _this0.$downFile(res);
        });
      }).catch(function () {});
    },
    getParams: function getParams() {
      var par = (0, _dataGrid.getAdvanceParams)(this.query, this.defaultQueryValue);
      if (!this.pagination) {
        this.pageParams.pageSize = 1000;
      }
      var union = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.pageParams), par);
      if (!union.sortColumn) {
        // 没有排序时使用默认排序
        if (!this.sumItemQty) {
          // 数量台账不启用创建时间排序
          union.sortColumn = this.sortColumn;
          union.sortOrder = this.sortOrder;
        }
      }
      return union;
    },
    // 查询重置
    resetQuery: function resetQuery() {
      this.defaultQueryValue = '';
      this.filterQuery.forEach(function (item) {
        if (item.value != undefined) {
          item.value = ''; // 统一设置为空字符串
        }
      });
      this.$emit('resetQuery');
    },
    // 每页条数改变时调用
    handleCurrentChange: function handleCurrentChange(page) {
      // 修改每页条数
      this.pageParams.pageSize = page.limit;
      // 获取最大页数
      var pageMax = Math.ceil(this.total / page.limit);
      // 判断跳转页数是否大于最大页数，如果大于，跳转页数就等于最大页数
      if (this.pageParams.pageNum <= pageMax) {
        // 获取表格数据
        this.handleQuery();
      }
    },
    // 分页查询
    handleQuery: function handleQuery() {
      var _this1 = this;
      var searchBtn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (!this.dataUrl) {
        this.loading = false;
        this.reLayout();
        return;
      }

      // 移除对 /dev-api/getInfo 接口的调用
      var union = this.getParams();
      this.loading = true;
      // 期间数据查询
      if (this.periodData) {
        union.conditions.push({
          column: 'period',
          exp: '=',
          value: this.periodData
        });
      }

      // 当点击的是搜索按钮时, 页数设为1
      if (searchBtn === 'searchBtn') {
        union.pageNum = 1;
        this.pageParams.pageNum = 1;
      }
      var config = Object.assign({
        url: this.dataUrl,
        method: 'POST',
        data: union
      }, this.setRequest);
      (0, _request.default)(config).then(function (response) {
        var _response$rows, _response$total;
        var items = (_response$rows = response.rows) !== null && _response$rows !== void 0 ? _response$rows : response.data;
        _this1.gridData = items;
        _this1.getData(items);
        _this1.total = (_response$total = response.total) !== null && _response$total !== void 0 ? _response$total : response.data.length;
        _this1.loading = false;
        _this1.reDoSelection();
        if (_this1.resize) {
          _this1.reLayout();
        }
        if (_this1.scanTag && items.length == 0) {
          _this1.$message.error('没有找到已审核的采购订单数据');
        } else {
          _this1.$emit('scan', _this1.gridData);
        }
      }).catch(function (error) {
        _this1.loading = false;
        console.error('请求失败:', error);
        _this1.$message.error('数据加载失败，请重试');
      });
    },
    /* 表格行宽度发生变化 */headerDragend: function headerDragend() {
      var _this$$refs;
      /* 对 Table 进行重新布局 */
      (_this$$refs = this.$refs) === null || _this$$refs === void 0 || _this$$refs.eltable.doLayout();
    }
  }
};